export const GET_BOOKING_CALENDARS = "GET_BOOKING_CALENDARS"
export const GET_BOOKING_CALENDARS_SUCCESS = "GET_BOOKING_CALENDARS_SUCCESS"
export const GET_BOOKING_CALENDARS_FAILED = "GET_BOOKING_CALENDARS_FAILED"

export const GET_BOOKINGS = "GET_BOOKINGS"
export const GET_BOOKINGS_SUCCESS = "GET_BOOKINGS_SUCCESS"
export const GET_BOOKINGS_FAILED = "GET_BOOKINGS_FAILED"

export const GET_SUB_CALENDARS = "GET_SUB_CALENDARS"
export const GET_SUB_CALENDARS_SUCCESS = "GET_SUB_CALENDARS_SUCCESS"
export const GET_SUB_CALENDARS_FAILED = "GET_SUB_CALENDARS_FAILED"

export const UPDATE_SUB_CALENDAR_STATUS = "UPDATE_SUB_CALENDAR_STATUS"
export const UPDATE_SUB_CALENDAR_STATUS_SUCCESS =
  "UPDATE_SUB_CALENDAR_STATUS_SUCCESS"
export const UPDATE_SUB_CALENDAR_STATUS_FAILED =
  "UPDATE_SUB_CALENDAR_STATUS_FAILED"

export const CREATE_BOOKING_CALENDAR = "CREATE_BOOKING_CALENDAR"
export const CREATE_BOOKING_CALENDAR_SUCCESS = "CREATE_BOOKING_CALENDAR_SUCCESS"
export const CREATE_BOOKING_CALENDAR_FAILED = "CREATE_BOOKING_CALENDAR_FAILED"

export const RESET_SELECTED_CALENDAR = "RESET_SELECTED_CALENDAR"

export const UPDATE_BOOKING_CALENDAR = "UPDATE_BOOKING_CALENDAR"
export const UPDATE_BOOKING_CALENDAR_SUCCESS = "UPDATE_BOOKING_CALENDAR_SUCCESS"
export const UPDATE_BOOKING_CALENDAR_FAILED = "UPDATE_BOOKING_CALENDAR_FAILED"

export const GET_SUB_CALENDAR = "GET_SUB_CALENDAR"
export const GET_SUB_CALENDAR_SUCCESS = "GET_SUB_CALENDAR_SUCCESS"
export const GET_SUB_CALENDAR_FAILED = "GET_SUB_CALENDAR_FAILED"
export const RESET_SUB_CALENDAR = "RESET_SUB_CALENDAR"

export const GET_ALL_CALENDARS = "GET_ALL_CALENDARS"
export const GET_ALL_CALENDARS_SUCCESS = "GET_ALL_CALENDARS_SUCCESS"
export const GET_ALL_CALENDARS_FAILED = "GET_ALL_CALENDARS_FAILED"

export const CREATE_BOOKING = "CREATE_BOOKING"
export const CREATE_BOOKING_SUCCESS = "CREATE_BOOKING_SUCCESS"
export const CREATE_BOOKING_FAILED = "CREATE_BOOKING_FAILED"

export const OPEN_CREATE_BOOKING_MODAL = "OPEN_CREATE_BOOKING_MODAL"
export const HIDE_CREATE_BOOKING_MODAL = "HIDE_CREATE_BOOKING_MODAL"
export const OPEN_CREATE_BOOKING_WARNING_MODAL =
  "OPEN_CREATE_BOOKING_WARNING_MODAL"
export const HIDE_CREATE_BOOKING_WARNING_MODAL =
  "HIDE_CREATE_BOOKING_WARNING_MODAL"

export const GET_ALL_SUB_CALENDARS = "GET_ALL_SUB_CALENDARS"
export const GET_ALL_SUB_CALENDARS_SUCCESS = "GET_ALL_SUB_CALENDARS_SUCCESS"
export const GET_ALL_SUB_CALENDARS_FAILED = "GET_ALL_SUB_CALENDARS_FAILED"

export const CREATE_SUB_CALENDAR = "CREATE_SUB_CALENDAR"
export const CREATE_SUB_CALENDAR_SUCCESS = "CREATE_SUB_CALENDAR_SUCCESS"
export const CREATE_SUB_CALENDAR_FAILED = "CREATE_SUB_CALENDAR_FAILED"

export const CLONE_CALENDAR = "CLONE_CALENDAR"
export const CLONE_CALENDAR_SUCCESS = "CLONE_CALENDAR_SUCCESS"
export const CLONE_CALENDAR_FAILED = "CLONE_CALENDAR_FAILED"
export const OPEN_CLONE_CALENDAR_MODAL = "OPEN_CLONE_CALENDAR_MODAL"
export const HIDE_CLONE_CALENDAR_MODAL = "HIDE_CLONE_CALENDAR_MODAL"

export const DELETE_CALENDAR = "DELETE_CALENDAR"
export const DELETE_CALENDAR_SUCCESS = "DELETE_CALENDAR_SUCCESS"
export const DELETE_CALENDAR_FAILED = "DELETE_CALENDAR_FAILED"
export const OPEN_DELETE_CALENDAR_MODAL = "OPEN_DELETE_CALENDAR_MODAL"
export const HIDE_DELETE_CALENDAR_MODAL = "HIDE_DELETE_CALENDAR_MODAL"
export const CHECK_CALENDAR_CAN_BE_DELETED = "CHECK_CALENDAR_CAN_BE_DELETED"
export const CHECK_CALENDAR_CAN_BE_DELETED_SUCCESS =
  "CHECK_CALENDAR_CAN_BE_DELETED_SUCCESS"
export const CHECK_CALENDAR_CAN_BE_DELETED_FAILED =
  "CHECK_CALENDAR_CAN_BE_DELETED_FAILED"

export const GET_CALENDAR = "GET_CALENDAR"
export const GET_CALENDAR_SUCCESS = "GET_CALENDAR_SUCCESS"
export const GET_CALENDAR_FAILED = "GET_CALENDAR_FAILED"

export const DELETE_SUB_CALENDAR = "DELETE_SUB_CALENDAR"
export const DELETE_SUB_CALENDAR_SUCCESS = "DELETE_SUB_CALENDAR_SUCCESS"
export const DELETE_SUB_CALENDAR_FAILED = "DELETE_SUB_CALENDAR_FAILED"
export const OPEN_DELETE_SUB_CALENDAR_MODAL = "OPEN_DELETE_SUB_CALENDAR_MODAL"
export const HIDE_DELETE_SUB_CALENDAR_MODAL = "HIDE_DELETE_SUB_CALENDAR_MODAL"

export const UPDATE_SUB_CALENDAR = "UPDATE_SUB_CALENDAR"
export const UPDATE_SUB_CALENDAR_SUCCESS = "UPDATE_SUB_CALENDAR_SUCCESS"
export const UPDATE_SUB_CALENDAR_FAILED = "UPDATE_SUB_CALENDAR_FAILED"

export const SET_BOOKING_CHECKOUT_SESSION = "SET_BOOKING_CHECKOUT_SESSION"

export const GET_SELECTED_BOOKING = "GET_SELECTED_BOOKING"
export const GET_SELECTED_BOOKING_SUCCESS = "GET_SELECTED_BOOKING_SUCCESS"
export const GET_SELECTED_BOOKING_FAILED = "GET_SELECTED_BOOKING_FAILED"
export const RESET_SELECTED_BOOKING = "RESET_SELECTED_BOOKING"

export const CLONE_SUB_CALENDAR = "CLONE_SUB_CALENDAR"
export const CLONE_SUB_CALENDAR_SUCCESS = "CLONE_SUB_CALENDAR_SUCCESS"
export const CLONE_SUB_CALENDAR_FAILED = "CLONE_SUB_CALENDAR_FAILED"

export const REORDER_CALENDARS = "REORDER_CALENDARS"
export const REORDER_SUB_CALENDARS = "REORDER_SUB_CALENDARS"
export const REORDER_CALENDARS_SUCCESS = "REORDER_CALENDARS_SUCCESS"
export const REORDER_SUB_CALENDARS_SUCCESS = "REORDER_SUB_CALENDARS_SUCCESS"

export const CONNECT_OUTLOOK = "CONNECT_OUTLOOK"
export const CONNECT_OUTLOOK_SUCCESS = "CONNECT_OUTLOOK_SUCCESS"
export const CONNECT_OUTLOOK_FAILED = "CONNECT_OUTLOOK_FAILED"

export const DISCONNECT_CALENDAR = "DISCONNECT_CALENDAR"
export const DISCONNECT_CALENDAR_SUCCESS = "DISCONNECT_CALENDAR_SUCCESS"
export const DISCONNECT_CALENDAR_FAILED = "DISCONNECT_CALENDAR_FAILED"

export const GET_OUTLOOK_CALENDARS = "GET_OUTLOOK_CALENDARS"
export const GET_OUTLOOK_CALENDARS_SUCCESS = "GET_OUTLOOK_CALENDARS_SUCCESS"
export const GET_OUTLOOK_CALENDARS_FAILED = "GET_OUTLOOK_CALENDARS_FAILED"

export const SYNC_OUTLOOK_CALENDARS = "SYNC_OUTLOOK_CALENDARS"
export const SYNC_OUTLOOK_CALENDARS_SUCCESS = "SYNC_OUTLOOK_CALENDARS_SUCCESS"
export const SYNC_OUTLOOK_CALENDARS_FAILED = "SYNC_OUTLOOK_CALENDARS_FAILED"

export const GET_SUB_CALENDAR_REPORTS = "GET_SUB_CALENDAR_REPORTS"
export const GET_SUB_CALENDAR_REPORTS_SUCCESS =
  "GET_SUB_CALENDAR_REPORTS_SUCCESS"
export const GET_SUB_CALENDAR_REPORTS_FAILED = "GET_SUB_CALENDAR_REPORTS_FAILED"

export const GET_BOOKING_DATE_REPORTS = "GET_BOOKING_DATE_REPORTS"
export const GET_BOOKING_DATE_REPORTS_SUCCESS =
  "GET_BOOKING_DATE_REPORTS_SUCCESS"
export const GET_BOOKING_DATE_REPORTS_FAILED = "GET_BOOKING_DATE_REPORTS_FAILED"
export const RESET_BOOKING_DATE_REPORTS = "RESET_BOOKING_DATE_REPORTS"

export const GET_CALENDAR_GROUP_REPORTS = "GET_CALENDAR_GROUP_REPORTS"
export const GET_CALENDAR_GROUP_REPORTS_SUCCESS =
  "GET_CALENDAR_GROUP_REPORTS_SUCCESS"
export const GET_CALENDAR_GROUP_REPORTS_FAILED =
  "GET_CALENDAR_GROUP_REPORTS_FAILED"

export const GET_BOOKING_STATUS_REPORTS = "GET_BOOKING_STATUS_REPORTS"
export const GET_BOOKING_STATUS_REPORTS_SUCCESS =
  "GET_BOOKING_STATUS_REPORTS_SUCCESS"
export const GET_BOOKING_STATUS_REPORTS_FAILED =
  "GET_BOOKING_STATUS_REPORTS_FAILED"

export const GET_USER_BOOKING_REPORTS = "GET_USER_BOOKING_REPORTS"
export const GET_USER_BOOKING_REPORTS_SUCCESS =
  "GET_USER_BOOKING_REPORTS_SUCCESS"
export const GET_USER_BOOKING_REPORTS_FAILED = "GET_USER_BOOKING_REPORTS_FAILED"

export const GET_BOOKING_REPORTS = "GET_BOOKING_REPORTS"
export const GET_BOOKING_REPORTS_SUCCESS = "GET_BOOKING_REPORTS_SUCCESS"
export const GET_BOOKING_REPORTS_FAILED = "GET_BOOKING_REPORTS_FAILED"

export const UPDATE_BOOKING = "UPDATE_BOOKING"
export const UPDATE_BOOKING_SUCCESS = "UPDATE_BOOKING_SUCCESS"
export const UPDATE_BOOKING_FAILED = "UPDATE_BOOKING_FAILED"

export const CANCEL_BOOKING = "CANCEL_BOOKING"
export const CANCEL_BOOKING_SUCCESS = "CANCEL_BOOKING_SUCCESS"
export const CANCEL_BOOKING_FAILED = "CANCEL_BOOKING_FAILED"

export const REFUND_BOOKING = "REFUND_BOOKING"
export const REFUND_BOOKING_SUCCESS = "REFUND_BOOKING_SUCCESS"
export const REFUND_BOOKING_FAILED = "REFUND_BOOKING_FAILED"

export const RESET_BOOKING_FEATURE = "RESET_BOOKING_FEATURE"
